(() => {
  function initialize(root) {
    if (!root || root.dataset.mpReady) return;
    root.dataset.mpReady = 'true';
    const thumbnails = [...root.querySelectorAll('[data-mp-thumbnail]')];
    const slides = [...root.querySelectorAll('[data-mp-slide]')];
    let current = 0;
    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; slide.classList.toggle('is-active', i === current); });
      thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
      const counter = root.querySelector('[data-mp-index]');
      if (counter) counter.textContent = String(current + 1).padStart(2, '0');
    }
    thumbnails.forEach((button, i) => {
      button.addEventListener('click', () => show(i));
      button.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1)); thumbnails[current].focus();
        }
      });
    });
    const stage = root.querySelector('.mp-gallery-stage');
    let touchStart = null;
    stage?.addEventListener('touchstart', event => { touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY }; }, {passive:true});
    stage?.addEventListener('touchend', event => {
      if (!touchStart) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) show(current + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, {passive:true});
    root.querySelectorAll('[data-mp-quantity]').forEach(button => {
      button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.mpQuantity));
        input.dispatchEvent(new Event('change', {bubbles:true}));
      });
    });
    const select = root.querySelector('[data-mp-variant]');
    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const add = root.querySelector('[data-mp-add]');
      const price = root.querySelector('[data-mp-price]');
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price;
      if (add) { add.disabled = !available; add.replaceChildren(document.createTextNode(available ? add.dataset.availableLabel : add.dataset.unavailableLabel)); }
      const oldCompare = root.querySelector('[data-mp-compare]');
      if (oldCompare) oldCompare.hidden = true;
      const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState(null, '', url);
    });
    const sticky = root.querySelector('.mp-sticky-buy');
    const buy = root.querySelector('.mp-commerce');
    if (sticky && buy) {
      let scheduled = false;
      const updateSticky = () => {
        sticky.classList.toggle('is-visible', buy.getBoundingClientRect().bottom < 0);
        scheduled = false;
      };
      const scheduleSticky = () => {
        if (!scheduled) { scheduled = true; requestAnimationFrame(updateSticky); }
      };
      window.addEventListener('scroll', scheduleSticky, {passive:true});
      window.addEventListener('resize', scheduleSticky, {passive:true});
      if ('IntersectionObserver' in window) new IntersectionObserver(scheduleSticky).observe(buy);
      updateSticky();
    }
  }
  document.querySelectorAll('[data-mp-product]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mp-product]').forEach(initialize));
})();
